module.exports = require('../impls/$starts-with-seq/starts-with-seq.js').__startsWithSeq;